import { jsxs, jsx } from 'react/jsx-runtime';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const IconLlmArrowUp = /*#__PURE__*/React.forwardRef((props, ref) => {
  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    className: "icon-llm-arrow-up",
    "data-icon": "icon-llm-arrow-up",
    "aria-hidden": "true"
  }, props, {
    ref: ref,
    children: [jsx("path", {
      d: "M12 20.25V3.75",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), jsx("path", {
      d: "M5.25 10.5L12 3.75L18.75 10.5",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
});
IconLlmArrowUp.displayName = 'IconLlmArrowUp';

export { IconLlmArrowUp };
//# sourceMappingURL=llm-arrow-up.js.map
